import { apiGet, apiPost, apiPut, apiDelete } from './api'
import type { ChecklistTemplate, ChecklistTemplateCreate, ChecklistTemplateVersion, Checklist, ChecklistItemUpdate } from '../types'

export const checklistApi = {
  getTemplates(projectId?: string): Promise<ChecklistTemplate[]> {
    const query = projectId ? `?projectId=${projectId}` : ''
    return apiGet<ChecklistTemplate[]>(`/checklists/templates${query}`)
  },

  getTemplate(id: string): Promise<ChecklistTemplate> {
    return apiGet<ChecklistTemplate>(`/checklists/templates/${id}`)
  },

  createTemplate(data: ChecklistTemplateCreate): Promise<ChecklistTemplate> {
    return apiPost<ChecklistTemplate>('/checklists/templates', data)
  },

  updateTemplate(id: string, data: Partial<ChecklistTemplateCreate>): Promise<ChecklistTemplate> {
    return apiPut<ChecklistTemplate>(`/checklists/templates/${id}`, data)
  },

  deleteTemplate(id: string): Promise<void> {
    return apiDelete(`/checklists/templates/${id}`)
  },

  copyTemplate(id: string, name?: string): Promise<ChecklistTemplate> {
    return apiPost<ChecklistTemplate>(`/checklists/templates/${id}/copy`, name ? { name } : {})
  },

  getTemplateVersions(id: string): Promise<ChecklistTemplateVersion[]> {
    return apiGet<ChecklistTemplateVersion[]>(`/checklists/templates/${id}/versions`)
  },

  getByProject(projectId: string, status?: string): Promise<Checklist[]> {
    const query = status ? `?status=${encodeURIComponent(status)}` : ''
    return apiGet<Checklist[]>(`/checklists/project/${projectId}${query}`)
  },

  getById(id: string): Promise<Checklist> {
    return apiGet<Checklist>(`/checklists/${id}`)
  },

  create(data: { projectId: string; templateId: string; systemId?: string; equipmentId?: string; assignedTo?: string }): Promise<Checklist> {
    return apiPost<Checklist>('/checklists', data)
  },

  updateItem(checklistId: string, itemId: string, data: ChecklistItemUpdate): Promise<void> {
    return apiPut(`/checklists/${checklistId}/items/${itemId}`, data)
  },

  deleteItem(checklistId: string, itemId: string): Promise<void> {
    return apiDelete(`/checklists/${checklistId}/items/${itemId}`)
  },

  complete(id: string): Promise<Checklist> {
    return apiPost<Checklist>(`/checklists/${id}/complete`)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/checklists/${id}`)
  },
}
